'use strict';

import React from 'react';

import { OnSchedUtils } from '../../utils';

import Form from '../Form/Form';


const Wizard = ({ element, form, onSubmit, onschedState }) => {
  const cancel = element.options.cancel ? element.options.cancel : null;

  let fields = {};

  Object.keys(OnSchedUtils.Forms(element, onschedState)[form]).map(k => {
    if (element.options.hide) {
      if (!element.options.hide.includes(k) || OnSchedUtils.Forms(element, onschedState)[form][k].required) {
        fields[k] = OnSchedUtils.Forms(element, onschedState)[form][k];
      }
    }
    else {
      fields[k] = OnSchedUtils.Forms(element, onschedState)[form][k];
    }
  })

  // React.useEffect(() => {
  //   const timezonesUrl = element.onsched.setupApiBaseUrl + '/companies/timezones/' + moment().format('YYYY-MM-DD');
  //   OnSchedRest.Get(timezonesUrl, response => setTimezones(response));
    
  //   if (element.params.id) {
  //     const elementRequested = element.type.replace('Setup', '') + 's';
  //     const url = element.onsched.setupApiBaseUrl + '/' + elementRequested + '/' + element.params.id;
      
  //     OnSchedRest.Get(url, response => {
  //       onschedState.setState(Object.assign(onschedState.state, { [response.object]: response }))
  //     });
  //   }
  // }, [])

  const submit = e => {
    e.preventDefault();
    let formData = new FormData(e.target);
    let formValues = {};

    // iterate through entries...
    for (var pair of formData.entries()) {
      formValues[pair[0]] = pair[1];
    }

    onSubmit(formValues)
  }

  return (
    <div className="Wizard">
        <Form 
          form={fields} 
          onschedState={onschedState}
          submit={onSubmit ? submit : null} 
          cancel={cancel} 
          element={element}
        />
    </div>
  )
}

export default Wizard
